(function($, Drupal, focusTrap) {
  'use strict';

  Drupal.behaviors.verticalContentCarousel = {
    attach: function(context, settings) {

      const initVCC = function($vcc) {
        const $vccControl = $vcc.find('.slider-control');
        const nSlides = $vccControl.children().length;
        const $prevArrow = $vccControl.parent().find('.up-arrow');
        const $nextArrow = $vccControl.parent().find('.down-arrow');
        const $vccContent = $vcc.find('.slider-content');
        // Slick init controls
        $vccControl
          .on('init', function(event, slick) {
            const $controls = slick.$slider;
            const $content = $controls.closest('.block-vertical-content-carousel').find('.slider-content');
            $controls.find('[data-slick-index]').unbind().bind('click mouseenter focus', function(e) {
              clearTimeout(window.sliderBounce);
              if (window.innerWidth >= 768) {
                window.sliderBounce = setTimeout(function() {
                  const $slide = jQuery(e.target);
                  let index = 0;
                  if ($slide.attr('data-slick-index')) {
                    index = parseInt($slide.attr('data-slick-index'));
                  }
                  else {
                    index = parseInt($slide.closest('[data-slick-index]').attr('data-slick-index'));
                  }
                  $content.slick('slickGoTo', index);
                }, 200);
              }
            });
          })
          .slick({
            slidesToShow: nSlides,
            slidesToScroll: 1,
            useTransform: false,
            rows: 0,
            arrows: false,
            dots: false,
            slide: '.slider-control-item',
            vertical: true,
            swipe: false,
            touchMove: false,
            asNavFor: $vccContent,
            focusOnSelect: false,
            centerMode: false,
            accessibility: false, // disable negative tabindex for still visible items
            variableHeight: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  vertical: false
                }
              }
            ]
          });

        $vccContent.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 0,
          asNavFor: $vccControl,
          slide: '.slider-content-item',
          dots: false,
          arrows: false,
          fade: true,
          swipe: false,
          touchMove: false,
          centerMode: true,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                variableHeight: true,
                touchMove: true
              }
            }
          ]
        });

        $nextArrow.on('click', function() {
          $vccContent.slick('slickNext');
        });
        $prevArrow.on('click', function() {
          $vccContent.slick('slickPrev');
        });
      };
      jQuery('.vertical-content-carousel').once('vcc-init').each(function() {
        const $vcc = jQuery(this);
        initVCC($vcc);
      });
    }
  };
})(jQuery, Drupal, focusTrap);
